/* =================================================================
   Sofá Croacia — landing JS
   Variant switching · gallery sync · sticky ATC · FAQ accordion
   Vanilla, no dependencies.
   ================================================================= */
(function () {
  'use strict';

  const productScript = document.querySelector('[data-croacia-product]');
  if (!productScript) return;

  const PRODUCT = JSON.parse(productScript.textContent);
  const moneyFormat =
    (window.Shopify && window.Shopify.currency && window.Shopify.money_format) ||
    '${{amount}}';

  // --- utilities -----------------------------------------------------
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  function money(cents) {
    // Try native Intl with MXN first (Brum is a Mexican store)
    try {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: PRODUCT.currency || 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return '$' + Math.round(cents / 100).toLocaleString('es-MX');
    }
  }

  // --- selected-options state ---------------------------------------
  const state = {
    options: PRODUCT.options.map((name, i) => {
      const firstVariant = PRODUCT.variants.find(v => v.available) || PRODUCT.variants[0];
      return firstVariant['option' + (i + 1)] || firstVariant.options[i];
    }),
    variant: null,
    quantity: 1,
  };

  function findVariant() {
    return PRODUCT.variants.find(v =>
      state.options.every((val, i) => (v['option' + (i + 1)] || v.options[i]) === val)
    );
  }

  function updateAll() {
    state.variant = findVariant();
    paintOptionStates();
    paintVariantIdInput();
    paintPrice();
    paintGallery();
    paintSticky();
    paintATC();
  }

  // --- paint: option buttons pressed state --------------------------
  function paintOptionStates() {
    $$('[data-croacia-opt]').forEach(btn => {
      const idx = parseInt(btn.dataset.croaciaOpt, 10) - 1;
      const value = btn.dataset.croaciaValue;
      btn.setAttribute('aria-pressed', state.options[idx] === value ? 'true' : 'false');

       // mark sold-out only if EVERY combination containing this value is unavailable
      const combosWithValue = PRODUCT.variants.filter(v => (v['option' + (idx + 1)] || v.options[idx]) === value);
      const allSoldOut = combosWithValue.length > 0 && combosWithValue.every(v => !v.available);
      if (allSoldOut) btn.dataset.soldOut = '';
      else delete btn.dataset.soldOut;
    });

    $$('[data-croacia-opt-current]').forEach(el => {
      const idx = parseInt(el.dataset.croaciaOptCurrent, 10) - 1;
      el.textContent = state.options[idx] || '';
    });
  }

  function paintVariantIdInput() {
    const input = $('[data-croacia-variant-id]');
    if (input && state.variant) input.value = state.variant.id;
  }

  // --- paint: price -------------------------------------------------
  function paintPrice() {
    if (!state.variant) return;
    const priceEl = $('[data-croacia-price]');
    const compareEl = $('[data-croacia-compare]');
    const savedEl = $('[data-croacia-saved]');
    if (priceEl) priceEl.textContent = money(state.variant.price);
    if (compareEl) {
      if (state.variant.compare_at_price && state.variant.compare_at_price > state.variant.price) {
        compareEl.textContent = money(state.variant.compare_at_price);
        compareEl.style.display = '';
        if (savedEl) {
          const pct = Math.round((state.variant.compare_at_price - state.variant.price) * 100 / state.variant.compare_at_price);
          savedEl.textContent = 'Ahorra ' + pct + '%';
          savedEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (savedEl) savedEl.style.display = 'none';
      }
    }
  }

  // --- paint: gallery swap based on active variant ------------------
  function paintGallery() {
    if (!state.variant) return;
    const imgs = $$('[data-croacia-gallery] .c-gallery__img');
    const variantId = state.variant.id;
    // Find first image with this variant id
    const match = imgs.find(im => (im.dataset.variantIds || '').split(',').map(Number).includes(variantId));
    // Fallback: match by color name in filename
    let target = match;
    if (!target) {
      const color = (state.options[findOptionIndexByName('color')] || '').toLowerCase();
      if (color) {
        target = imgs.find(im => (im.src || '').toLowerCase().includes(color))
              || imgs.find(im => (im.src || '').toLowerCase().includes('ocre') && color === 'naranja');
      }
    }
    if (!target) return;
    imgs.forEach(im => im.removeAttribute('data-active'));
    target.setAttribute('data-active', '');
    // sync thumb
    const idx = parseInt(target.dataset.idx, 10);
    $$('[data-croacia-gallery] .c-gallery__thumb').forEach(t =>
      t.setAttribute('aria-current', parseInt(t.dataset.idx, 10) === idx ? 'true' : 'false')
    );
  }

  function findOptionIndexByName(needle) {
    return PRODUCT.options.findIndex(n => n.toLowerCase().includes(needle));
  }

  // --- paint: sticky ATC bar ---------------------------------------
  function paintSticky() {
    if (!state.variant) return;
    const thumb = $('[data-croacia-sticky-thumb]');
    const vTitle = $('[data-croacia-sticky-variant]');
    const vPrice = $('[data-croacia-sticky-price]');
    if (thumb) {
      const activeImg = $('[data-croacia-gallery] .c-gallery__img[data-active]');
      if (activeImg) thumb.src = activeImg.src;
    }
    if (vTitle) {
      if (PRODUCT.options.length === 1 && PRODUCT.options[0].toLowerCase() === 'title') {
        vTitle.textContent = PRODUCT.title;
      } else {
        vTitle.textContent = state.options.join(' · ');
      }
    }
    if (vPrice) vPrice.textContent = money(state.variant.price);
  }

  // --- paint: ATC button state --------------------------------------
  function paintATC() {
    const btn = $('[data-croacia-atc]');
    const label = $('[data-croacia-atc-label]');
    const sticky = $('[data-croacia-sticky-atc]');
    if (!state.variant || !state.variant.available) {
      if (btn) btn.setAttribute('disabled', '');
      if (label) label.textContent = 'Agotado';
      if (sticky) { sticky.setAttribute('disabled', ''); sticky.textContent = 'Agotado'; }
    } else {
      if (btn) btn.removeAttribute('disabled');
      if (label) label.textContent = 'Agregar al carrito';
      if (sticky) { sticky.removeAttribute('disabled'); sticky.textContent = 'Agregar'; }
    }
  }

  // --- events: option buttons ---------------------------------------
  document.addEventListener('click', function (e) {
    const opt = e.target.closest('[data-croacia-opt]');
    if (opt && !opt.dataset.soldOut) {
      const idx = parseInt(opt.dataset.croaciaOpt, 10) - 1;
      state.options[idx] = opt.dataset.croaciaValue;
      updateAll();
      return;
    }

    // Color cards (from the mosaic section): pick color, scroll to ficha
    const pick = e.target.closest('[data-croacia-pick-color]');
    if (pick) {
      const color = pick.dataset.croaciaPickColor;
      const optIndex = parseInt(pick.dataset.croaciaColorOptionIndex, 10) - 1;
      if (optIndex >= 0 && color) {
        state.options[optIndex] = color;
        updateAll();
        const ficha = document.getElementById('CroaciaFicha');
        if (ficha) ficha.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    // Gallery thumb
    const thumb = e.target.closest('[data-croacia-gallery] .c-gallery__thumb');
    if (thumb) {
      const idx = parseInt(thumb.dataset.idx, 10);
      $$('[data-croacia-gallery] .c-gallery__img').forEach(im =>
        parseInt(im.dataset.idx, 10) === idx ? im.setAttribute('data-active', '') : im.removeAttribute('data-active')
      );
      $$('[data-croacia-gallery] .c-gallery__thumb').forEach(t =>
        t.setAttribute('aria-current', parseInt(t.dataset.idx, 10) === idx ? 'true' : 'false')
      );
      return;
    }

    // Qty steppers
    const qty = e.target.closest('[data-croacia-qty]');
    if (qty) {
      const input = $('[data-croacia-qty-input]');
      if (!input) return;
      const step = parseInt(qty.dataset.croaciaQty, 10);
      const next = Math.max(1, parseInt(input.value, 10) + step);
      input.value = next;
      state.quantity = next;
      return;
    }
    // Rating click → scroll to reviews section
    const ratingLink = e.target.closest('[data-croacia-scroll-reviews]');
    if (ratingLink) {
      e.preventDefault();
      const target = document.getElementById('CroaciaReviews');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    // Sticky ATC click → add to cart via fetch
    const stickyAtc = e.target.closest('[data-croacia-sticky-atc]');
    if (stickyAtc) {
      e.preventDefault();
      addToCart(stickyAtc);
      return;
    }

    // FAQ toggle
    const faqBtn = e.target.closest('.c-faq__q');
    if (faqBtn) {
      const expanded = faqBtn.getAttribute('aria-expanded') === 'true';
      faqBtn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      const panel = faqBtn.nextElementSibling;
      if (panel) {
        if (expanded) {
          panel.style.maxHeight = '0px';
          setTimeout(() => { panel.hidden = true; }, 300);
        } else {
          panel.hidden = false;
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      }
      return;
    }
  });

  // --- form submit: ATC via fetch (keeps drawer UX of theme) --------
  const form = $('[data-croacia-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = $('[data-croacia-atc]');
      addToCart(btn);
    });
  }

  function addToCart(btn) {
    if (!state.variant) {
      console.warn('Croacia ATC: no variant selected');
      return;
    }
    if (!state.variant.available) {
      console.warn('Croacia ATC: variant unavailable');
      return;
    }

    if (btn) btn.setAttribute('aria-busy', 'true');
    const atcLabel = document.querySelector('[data-croacia-atc-label]');
    if (atcLabel) atcLabel.textContent = 'Agregando…';

    const body = new FormData();
    body.append('id', state.variant.id);
    body.append('quantity', state.quantity || 1);

    fetch('/cart/add.js', {
      method: 'POST',
      body: body,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(r => {
      if (!r.ok) return r.json().then(err => { throw err; });
      return r.json();
    })
    .then((item) => {
      // Notify the theme (Warehouse listens to these event names)
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { item } }));
      document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { item } }));

      // Try to open Warehouse's mini-cart (custom element <mini-cart>)
      let opened = false;
      const miniCart = document.querySelector('mini-cart, cart-drawer');
      if (miniCart) {
        if (typeof miniCart.open === 'function') { miniCart.open(); opened = true; }
        else if (typeof miniCart.show === 'function') { miniCart.show(); opened = true; }
      }
      if (!opened) {
        const triggerBtn = document.querySelector(
          'button[aria-controls="mini-cart-drawer"], button[data-action="open-drawer"][data-drawer-id*="cart"], button[data-action="open-mini-cart"]'
        );
        if (triggerBtn) { triggerBtn.click(); opened = true; }
      }

      // Show success state
      if (btn) {
        btn.removeAttribute('aria-busy');
        if (atcLabel) atcLabel.textContent = '✓ Agregado al carrito';
        setTimeout(() => {
          if (atcLabel) atcLabel.textContent = 'Agregar al carrito';
        }, 2200);
      }

      // If no drawer opened, go to cart page after a brief moment
      if (!opened) {
        setTimeout(() => { window.location.href = '/cart'; }, 700);
      }
    })
    .catch((err) => {
      console.error('Croacia ATC error:', err);
      if (btn) btn.removeAttribute('aria-busy');
      if (atcLabel) atcLabel.textContent = 'Error — reintentar';
      setTimeout(() => {
        if (atcLabel) atcLabel.textContent = 'Agregar al carrito';
      }, 2200);
    });
  }

  // --- sticky ATC visibility toggle ---------------------------------
  const stickyEl = $('[data-croacia-sticky]');
  const ficha = $('#CroaciaFicha');
  if (stickyEl && ficha) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          stickyEl.removeAttribute('data-visible');
          stickyEl.setAttribute('aria-hidden', 'true');
        } else {
          stickyEl.setAttribute('data-visible', '');
          stickyEl.setAttribute('aria-hidden', 'false');
        }
      });
    }, { rootMargin: '-60% 0px 0px 0px', threshold: 0 });
    io.observe(ficha);
  }
  // --- Loox rating reveal -------------------------------------------
  // .c-rating está oculto por CSS hasta que Loox inyecte contenido real.
  // Si Loox no carga o el producto no tiene reseñas, queda oculto en vez
  // de aparecer como hueco antes del precio.
  (function revealLooxRating() {
    const ratingLink = $('[data-croacia-scroll-reviews]');
    const looxSlot = document.getElementById('looxRating');
    if (!ratingLink || !looxSlot) return;

    const hasContent = () => {
      const html = (looxSlot.innerHTML || '').trim();
      return html.length > 0 && (looxSlot.children.length > 0 || html.length > 4);
    };

    if (hasContent()) {
      ratingLink.classList.add('is-ready');
      return;
    }

    const mo = new MutationObserver(() => {
      if (hasContent()) {
        ratingLink.classList.add('is-ready');
        mo.disconnect();
        clearTimeout(stopTimer);
      }
    });
    mo.observe(looxSlot, { childList: true, subtree: true });

    const stopTimer = setTimeout(() => mo.disconnect(), 8000);
  })();

  // --- fade-in observer ---------------------------------------------
  if ('IntersectionObserver' in window) {
    const fi = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.setAttribute('data-visible', ''); fi.unobserve(e.target); }
      });
    }, { threshold: 0.08 });
    $$('.c-fade-in').forEach(el => fi.observe(el));
  } else {
    $$('.c-fade-in').forEach(el => el.setAttribute('data-visible', ''));
  }

  // Initial paint
  updateAll();
})();
